import { useTranslation } from 'react-i18next';
import styles from './Quote.module.css';

export function Quote() {
  const { t } = useTranslation();

  return (
    <section className={styles.section} aria-label={t('quote.source')}>
      <div className="container">
        <figure className={styles.figure}>
          <blockquote className={styles.quote}>{t('quote.text')}</blockquote>
          <figcaption className={styles.source}>{t('quote.source')}</figcaption>
        </figure>
      </div>
    </section>
  );
}
